import { useState } from 'react'
import { Modal } from './Modal'
import { classNames } from './utils'
import { Pdf } from './Pdf'

interface PdfPreviewProps {
  url: string
  showPreview: boolean
  onClose: () => void
}

export function PdfPreview({ url, showPreview, onClose }: PdfPreviewProps) {
  const [pdfLoaded, setPdfLoaded] = useState(false)

  return (
    <Modal
      size="4xl"
      fullHeight
      isOpen={showPreview}
      onClose={() => {
        onClose()
        setPdfLoaded(false)
      }}>
      <Modal.Title>PDF Preview</Modal.Title>
      <div
        className={classNames(
          '-mx-6 -mb-6 mt-4 flex h-full items-center justify-center overflow-x-hidden p-6',
          {
            'bg-gray-600': pdfLoaded
          }
        )}>
        <Pdf
          loadingText="Loading PDF Preview"
          url={url}
          onLoad={() => setPdfLoaded(true)}
        />
      </div>
    </Modal>
  )
}
